import React from 'react';
import { SimpleModal } from '../../../../components/SimpleModal';
import { SystemUnavailableProps } from '../../../../components/SystemUnavailable';
import { Button } from '../../../../components';
import WarningIcon from '../../../../components/WarningIcon';

export type DoctorFirstStepModalProps = {
  scheduleWithNurse: () => void;
} & SystemUnavailableProps;

export const DoctorsWithoutSlotsModal: React.FC<DoctorFirstStepModalProps> = ({
  visible,
  onClose,
  scheduleWithNurse
}) => {
  return (
    <SimpleModal
      visible={visible}
      onClose={onClose}
      title="Os médicos da família não possuem horários disponíveis"
      subtitle="<div><p>Os profissionais do nosso corpo clínico não possuem disponibilidade nos próximos 7 dias úteis.</p></div>"
      mainIcon={<WarningIcon />}
      customFooterContainer={
        <>
          <Button disabled={!visible} type="button" title="Agendar com enfermeiro" onClick={scheduleWithNurse} />
        </>
      }
    />
  );
};
